import React from 'react';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { makeStyles } from 'tss-react/mui';
import { Button } from '@mui/material';

export function AssessmentDialogSupportControlButton({
  icon,
  onClick,
  disabled,
  label,
  width = 150,
}: {
  icon: FontAwesomeIconProps['icon'];
  onClick: () => void;
  disabled?: boolean;
  label?: string;
  width?: number;
}) {
  const useStyles = makeStyles()(() =>
    ({
      customButton: {
        width,
        display: 'flex',
        alignItems: 'center',
        minHeight: 'auto',
        backgroundColor: '#f5f5f5',
        '&:hover': {
          backgroundColor: 'rgb(237, 235, 235)',
        },
        '&.Mui-disabled': {
          color: '#cccccc',
        },
      },
    })
  );
  const { classes } = useStyles();

  return (
    <Button
      disabled={disabled}
      className={classes.customButton}
      variant="outlined"
      onClick={onClick}
      color="primary"
    >
      {label && <span>{label}</span>}
      <div
        style={{
          marginLeft: label ? 'auto' : undefined,
          display: 'flex',
          alignItems: 'center',
          textAlign: 'center',
        }}
      >
        <FontAwesomeIcon size="xl" icon={icon} />
      </div>
    </Button>
  );
}
